import { chatWindowActions } from '../redux/slices/chat-window';
import { AppThunk } from '../redux/store';
import { requestToken } from '../redux/thunks/bruker';
import callGuideService from '../services/callguide-service';
import { ContactData } from '../types/call-guide/chat-api';
import webtrendsActions from './webtrendsActions';

function startChat(
  entrance: string,
  errand: string,
  visitorQuestion = '',
  initialContactData: ContactData = {},
  trackChat = false
): AppThunk<Promise<unknown>> {
  return async (dispatch, getState) => {
    await dispatch(requestToken());

    const state = getState();

    const contactData = { ...initialContactData, authToken: state.bruker.jwt };

    callGuideService.requestChat(
      entrance,
      errand,
      visitorQuestion,
      contactData
    );
    if (trackChat) {
      dispatch(webtrendsActions.trackStartChat());
    }

    // FIXME: This doesn't seem to do anything
    return dispatch({
      type: 'START_CHAT',
      entrance,
      errand,
      visitorQuestion,
      contactData
    });
  };
}

function startChatTrack(
  entrance: string,
  errand: string,
  visitorQuestion: string,
  contactData?: ContactData
) {
  return startChat(entrance, errand, visitorQuestion, contactData, true);
}

function hideChatActivations(): AppThunk {
  return (dispatch, getState) => {
    const { chatState } = getState();

    // TODO: This is a temp fix for an issue with the new Ace SDK, and should be removed when possible
    if (chatState.currentState === 'finished') {
      callGuideService.deleteSession();
    } else {
      dispatch(chatWindowActions.hideChatActivations());
    }
  };
}

function showChatActivations(): AppThunk {
  return (dispatch) => {
    dispatch(chatWindowActions.showChatActivations());
  };
}

function forceHideChatActivations(): AppThunk {
  return (dispatch) => {
    dispatch(chatWindowActions.forceHideChatActivations());
  };
}

const requestActions = {
  startChat,
  startChatTrack,
  hideChatActivations,
  showChatActivations,
  forceHideChatActivations
};

export type RequestCallbackActions = typeof requestActions;

export default requestActions;
